var render = function render(){var _vm=this,_c=_vm._self._c;return _c('top-bar-menu',{attrs:{"title":_vm.$t('common.exploitation'),"links":_vm.links,"content-class":"top-bar-menu__content"}})
}
var staticRenderFns = []

export { render, staticRenderFns }